var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 3H13.5V2.25C13.5 1.00734 12.4927 0 11.25 0H8.25C7.00734 0 6 1.00734 6 2.25V3H1.875C0.839484 3 0 3.83948 0 4.875V6.375C0 6.78923 0.335766 7.125 0.75 7.125H18.75C19.1642 7.125 19.5 6.78923 19.5 6.375V4.875C19.5 3.83948 18.6605 3 17.625 3ZM7.5 2.25C7.5 1.83656 7.83656 1.5 8.25 1.5H11.25C11.6634 1.5 12 1.83656 12 2.25V3H7.5V2.25Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42333 8.625C1.2895 8.625 1.18286 8.73684 1.18924 8.87053L1.80799 21.8569C1.86517 23.0588 2.85236 24 4.05517 24H15.4449C16.6477 24 17.6349 23.0588 17.692 21.8569L18.3108 8.87053C18.3172 8.73684 18.2105 8.625 18.0767 8.625H1.42333ZM12.75 10.5C12.75 10.0856 13.0856 9.75 13.5 9.75C13.9144 9.75 14.25 10.0856 14.25 10.5V20.25C14.25 20.6644 13.9144 21 13.5 21C13.0856 21 12.75 20.6644 12.75 20.25V10.5ZM9.00002 10.5C9.00002 10.0856 9.33564 9.75 9.75002 9.75C10.1644 9.75 10.5 10.0856 10.5 10.5V20.25C10.5 20.6644 10.1644 21 9.75002 21C9.33564 21 9.00002 20.6644 9.00002 20.25V10.5ZM5.25002 10.5C5.25002 10.0856 5.58564 9.75 6.00002 9.75C6.41439 9.75 6.75002 10.0856 6.75002 10.5V20.25C6.75002 20.6644 6.41439 21 6.00002 21C5.58564 21 5.25002 20.6644 5.25002 20.25V10.5Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinLabelIcon);
export default __webpack_public_path__ + "static/media/trashBinLabelIcon.80eb728a75d1f2569e0e213d6d1162d9.svg";
export { ForwardRef as ReactComponent };